import { SettingsTranslate } from './settingsTranslate.model';

const settingsTranslatePTBR: SettingsTranslate = {
  title: 'Configurações',
  tabsLabel: 'Seção',
  tabs: {
    studio: 'Estúdio',
    capture: 'Captação',
    templates: 'Modelos',
    contracts: 'Contratos',
    account: 'Conta',
    preferences: 'Preferências',
    followUp: 'Follow-up',
  },
  followUp: {
    title: 'Follow-up automático',
    description:
      'Crie tarefas sozinho quando um evento fica parado tempo demais numa etapa do quadro.',
    empty: 'Nenhuma regra criada',
    created: 'Regra criada',
    deleted: 'Regra removida',
    add: 'Adicionar regra',
    variablesHint: 'Use {{leadVar}} e {{eventVar}} no título da tarefa.',
    countingHint:
      'A contagem começa quando o evento entra na coluna. Editar descrição, data ou local não reinicia — só mudar de coluna reinicia.',
    scheduleHint:
      'As regras são avaliadas uma vez por dia, então nada aparece na hora. A primeira execução pode criar várias tarefas de uma vez, para os eventos que já estavam parados.',
    field: {
      status: 'Etapa do quadro',
      days: 'Dias parado',
      title: 'Título da tarefa',
    },
    rule: {
      summary: 'Parado há {{days}} dia(s) em {{status}}',
      active: 'Ativa',
      inactive: 'Inativa',
      remove: 'Remover regra',
    },
  },
  sections: {
    organization: {
      title: 'Organização',
    },
    theme: {
      title: 'Tema',
    },
    language: {
      title: 'Idioma',
    },
    security: {
      title: 'Segurança',
      changePassword: {
        label: 'Senha',
        button: 'Alterar senha',
      },
    },
    birthPhotographer: {
      title: 'Modo Especializado',
      label: 'Modo Fotografia de Parto',
      description:
        'Habilita campos específicos para fotógrafos de parto. Os dados permanecem salvos mesmo quando o modo está desativado.',
      error: 'Erro ao atualizar configuração',
    },
    leadCapture: {
      title: 'Formulário de captação',
      label: 'Formulário público de captação',
      description:
        'Gere um link público para captar novos leads. Os contatos enviados aparecem automaticamente na sua lista de clientes.',
      copy: 'Copiar link',
      tip: 'Dica: use este link na bio do seu Instagram.',
      disableConfirm: {
        title: 'Desativar formulário de captação',
        text: 'Tem certeza que deseja desativar o formulário de captação?',
        secondaryText: 'O link atual deixará de funcionar.',
        confirm: 'Desativar',
        cancel: 'Cancelar',
      },
      toast: {
        enabled: 'Formulário de captação ativado',
        disabled: 'Formulário de captação desativado',
        error: 'Não foi possível atualizar o formulário. Tente novamente',
        linkCopied: 'Link copiado',
        linkCopyError: 'Não foi possível copiar o link',
      },
    },
    messageTemplates: {
      title: 'Templates de mensagem',
    },
    checklists: {
      title: 'Checklists de evento',
    },
  },
  messageTemplates: {
    description:
      'Crie mensagens reutilizáveis com variáveis para enviar aos clientes.',
    add: 'Novo template',
    empty: 'Nenhum template cadastrado',
    actions: {
      edit: 'Editar template',
      delete: 'Excluir template',
    },
    delete: {
      title: 'Excluir template',
      text: 'Tem certeza que deseja excluir "{{name}}"?',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    toast: {
      deleted: 'Template excluído',
      error: 'Não foi possível excluir o template',
    },
    modal: {
      titleCreate: 'Novo template',
      titleEdit: 'Editar template',
      fields: {
        name: 'Nome do template',
        body: 'Mensagem',
      },
      errors: {
        name: {
          required: 'Nome é obrigatório',
          maxLength: 'Nome deve ter no máximo 120 caracteres',
        },
        body: {
          required: 'Mensagem é obrigatória',
          maxLength: 'Mensagem deve ter no máximo 2000 caracteres',
        },
      },
      variablesHint: 'Toque em uma variável para inseri-la na mensagem:',
      submit: 'Salvar',
      cancel: 'Cancelar',
      toast: {
        created: 'Template criado',
        updated: 'Template atualizado',
        error: 'Não foi possível salvar o template',
      },
    },
  },
  checklists: {
    description:
      'Crie checklists para aplicar em eventos com prazos relativos.',
    add: 'Novo checklist',
    empty: 'Nenhum checklist cadastrado',
    itemsCount: '{{count}} item(ns)',
    actions: {
      edit: 'Editar checklist',
      delete: 'Excluir checklist',
    },
    delete: {
      title: 'Excluir checklist',
      text: 'Tem certeza que deseja excluir "{{name}}"?',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    toast: {
      deleted: 'Checklist excluído',
      error: 'Não foi possível excluir o checklist',
    },
    modal: {
      titleCreate: 'Novo checklist',
      titleEdit: 'Editar checklist',
      fields: {
        name: 'Nome do checklist',
      },
      items: {
        title: 'Itens',
        add: 'Adicionar item',
        itemTitle: 'Título do item',
        offsetDays: 'Dias',
        offsetHint:
          'Dias relativos à data do evento (ex.: -7 = 7 dias antes, 0 = no dia).',
        remove: 'Remover item',
        empty: 'Nenhum item adicionado',
      },
      errors: {
        name: {
          required: 'Nome é obrigatório',
          maxLength: 'Nome deve ter no máximo 120 caracteres',
        },
        items: {
          required: 'Adicione ao menos um item',
        },
        itemTitle: {
          required: 'Título é obrigatório',
        },
      },
      submit: 'Salvar',
      cancel: 'Cancelar',
      toast: {
        created: 'Checklist criado',
        updated: 'Checklist atualizado',
        error: 'Não foi possível salvar o checklist',
      },
    },
  },
  organization: {
    name: {
      label: 'Nome da organização',
      placeholder: 'Nome da organização',
      submit: 'Salvar',
      success: 'Nome da organização atualizado com sucesso',
      errors: {
        required: 'Nome é obrigatório',
        minLength: 'O nome deve ter no mínimo 1 caractere',
        maxLength: 'O nome deve ter no máximo 256 caracteres',
      },
    },
  },
  changePassword: {
    modal: {
      title: 'Alterar senha',
    },
    fields: {
      currentPassword: 'Senha atual',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar nova senha',
    },
    passwordVisibility: {
      showCurrent: 'Mostrar senha atual',
      hideCurrent: 'Ocultar senha atual',
      showNew: 'Mostrar nova senha',
      hideNew: 'Ocultar nova senha',
      showConfirmation: 'Mostrar confirmação da nova senha',
      hideConfirmation: 'Ocultar confirmação da nova senha',
    },
    errors: {
      currentPassword: {
        required: 'Senha atual é obrigatória',
        invalid: 'Senha atual incorreta',
      },
      newPassword: {
        required: 'Nova senha é obrigatória',
        minLength: 'A senha deve ter no mínimo 8 caracteres',
      },
      confirmPassword: {
        required: 'Confirmação de senha é obrigatória',
        mismatch: 'As senhas não coincidem',
      },
    },
    success: 'Senha alterada com sucesso',
    submit: 'Salvar',
  },
};

export default settingsTranslatePTBR;
